import React, { useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import TeamPage from './pages/Team/page';
import SuccessPage from './pages/Success/page';
import TeamMembersPage from './pages/TeamMembers/page';
import './i18n'; // Import de la configuration i18next
import './App.css'; // Import du CSS pour le fond et les formes
import NotFoundPage from './pages/NotFound/page';
import QRCodeConfig from './pages/QRCode/page';
import UserPage from './pages/User/page';
import TeamPayPage from './pages/TeamPay/page';
import CancelPage from './pages/Cancel/page';
import InvitePage from './pages/Invite/page';


// Composant de redirection vers le site externe
const RedirectToExternalSite = () => {
  useEffect(() => {
    window.location.href = 'https://www.thetipsyou.fr';
  }, []);
  return null;
};


function App() {
  return (
    <div className="relative no-scroll min-h-screen bg-modern text-black flex flex-col justify-between overflow-hidden">
      <Routes>
        <Route path="/" element={<RedirectToExternalSite />} />
        <Route path="/user" element={<RedirectToExternalSite />} />
        <Route path="/team" element={<RedirectToExternalSite />} />
        <Route path="/team/:id" element={<TeamPage />} />
        <Route path="/user/:id" element={<UserPage />} />
        <Route path="/success" element={<SuccessPage />} />
        <Route path="/cancel" element={<CancelPage />} />
        <Route path="/qrCode/:id/" element={<QRCodeConfig />} />
        <Route path="/team/:id/members" element={<TeamMembersPage />} />
        <Route path="/team/:id/pay" element={<TeamPayPage />} />
        <Route path="/invite" element={<InvitePage />} />

        {/* Route pour les pages inconnues */}
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </div>
  );
}

export default function AppWrapper() {
  return (
    <Router>
      <App />
    </Router>
  );
}
